import { render, staticRenderFns } from "./ModalAddTrans.vue?vue&type=template&id=c167ac7e&"
import script from "./ModalAddTrans.vue?vue&type=script&lang=js&"
export * from "./ModalAddTrans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports